// extracted by mini-css-extract-plugin
export default {"root":"root__norxQOQ7","contextMenu":"context-menu__fJIj0WOJ"};